export enum TrackDomain {
    ArboPark = "arbopark",
    Tomkart = "tomkart"
}